<template>
  <div id="divPDFMobile">
    <canvas id="pdfCanvas"></canvas>
    <v-btn v-show="isLoaded" color="warning" fab small class="btnZoomIn" @click.native="zoomMobile('+')">
      <v-icon>add</v-icon>
    </v-btn>
    <v-btn v-show="isLoaded" color="warning" fab small class="btnZoomOut" @click.native="zoomMobile('-')">
      <v-icon>remove</v-icon>
    </v-btn>
  </div>
</template>
<script>
  import JSZip from 'jszip';
  import PDFJS from 'pdfjs-dist';

  export default {
    name: 'PdfMobile',
    props: ['url'],
    data() {
      return {
        isShow: false,
        isLoaded: false,
        isZooming: false,
        pdfContent: 'בחר קובץ מהתפריט',
        pdfDoc: null,
        pageNum: 0,
        scale: 1.0,
        ctx: ''
      }
    },
    created() {
      this.$Log("Vue [PdfMobile] is created ...");
    },
    ready() {
      this.$Log("Vue [PdfMobile] is ready ...");
    },
    mounted() {
      this.$Log("Vue [PdfMobile] is mounted ...");
      //PDFJS.GlobalWorkerOptions.workerSrc = 'https://mozilla.github.io/pdf.js/build/pdf.worker.js';
      PDFJS.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.0.489/pdf.worker.min.js';
    },
    updated() {
      this.$Log("Vue [PdfMobile] is updated ...");
    },
    watch: {
      url(val) {
        this.isLoaded = false;
        this.loadPDF();
        //this.renderPDF();

        //if (PDFObject.supportsPDFs) {
        //  PDFObject.embed(this.url, "#divPDF");
        //}
        //else {
        //  this.pdfContent = "PDF not supported";
        //}
      }
    },
    computed: {
    },
    methods: {
      loadPDF() {
        var vm = this;
        vm.isLoaded = false;
        JSZipUtils.getBinaryContent(vm.url, function (err, data) {
          if (!err) {
            // data
            console.log(data);
            //PDFJS.getDocument(data)
            vm.pageNum = 1;
            PDFJS.getDocument(data).then(function getPdf(_pdfDoc) {
              vm.pdfDoc = _pdfDoc;
              //vm.renderPage(pageNum);
              vm.canvas = document.getElementById('pdfCanvas');
              vm.ctx = vm.canvas.getContext('2d');
              vm.pdfDoc.getPage(vm.pageNum).then(function (page) {
                var viewport = page.getViewport(vm.scale);
                vm.canvas.height = viewport.height;
                vm.canvas.width = viewport.width;
                // Render PDF page into canvas context
                var renderContext = {
                  canvasContext: vm.ctx,
                  viewport: viewport
                };
                page.render(renderContext);
                vm.isLoaded = true;
              });

            });
          }
        });
      },
      zoomMobile(sign) {
        var vm = this;

        try {
          vm.pageNum = 1;
          if (sign == "+") { vm.scale = vm.scale + 0.1; }
          if (sign == "-") { vm.scale = vm.scale - 0.1; }

          if (vm.scale < 0.25) { vm.scale = 0.25; }
          if (vm.scale > 4) { vm.scale = 4; }
          if (!vm.isZooming) {
            vm.canvas = document.getElementById('pdfCanvas');
            vm.ctx = vm.canvas.getContext('2d');
            vm.isZooming = true;
            vm.pdfDoc.getPage(vm.pageNum).then(function (page) {
              var viewport = page.getViewport(vm.scale);
              vm.canvas.height = viewport.height;
              vm.canvas.width = viewport.width;
              // Render PDF page into canvas context
              var renderContext = {
                canvasContext: vm.ctx,
                viewport: viewport
              };
              //page.render(renderContext);
              page.render(renderContext).then(function () {
                console.log("FINISHED RENDERING!");
                vm.isZooming = false;
              }, function () {
                console.log("ERROR");
                vm.isZooming = true;
              });
            });
          }
        }
        catch (e) {
          console.log("Canavs is zooming...");
        }
      },
      renderPDF() {
        //https://mozilla.github.io/pdf.js/build/pdf.worker.js
        //https://mozilla.github.io/pdf.js/build/pdf.js

        var vm = this;
        vm.pdfDoc = null;
        vm.pageNum = 1;
        vm.scale = 1;
        vm.canvas = document.getElementById('pdfCanvas');
        vm.ctx = canvas.getContext('2d');
        PDFJS.disableWorker = true;
        PDFJS.getDocument(vm.url).then(function getPdf(_pdfDoc) {
          pdfDoc = _pdfDoc;
          renderPage(pageNum);
        });
      },
      base64ToUint8Array(base64) {//base64 is an encoded byte Array sent from server-side
        var raw = atob(base64); //This is a native function that decodes a base64-encoded string.
        var uint8Array = new Uint8Array(new ArrayBuffer(raw.length));
        for (var i = 0; i < raw.length; i++) {
          uint8Array[i] = raw.charCodeAt(i);
        }
        return uint8Array;
      },
      renderPage(num) {
        // Using promise to fetch the page
        pdfDoc.getPage(num).then(function (page) {
          var viewport = page.getViewport(scale);
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          // Render PDF page into canvas context
          var renderContext = {
            canvasContext: ctx,
            viewport: viewport
          };
          page.render(renderContext);
        });
        // Update page counters
        document.getElementById('page_num').textContent = pageNum;
        document.getElementById('page_count').textContent = pdfDoc.numPages;
      },
      goPrevious() {
        if (pageNum <= 1)
          return;
        pageNum-- ;
        renderPage(pageNum);
      },
      goNext() {
        if (pageNum >= pdfDoc.numPages)
          return;
        pageNum++;
        renderPage(pageNum);
      },
      zoom(newScale) {
        // Using promise to fetch the page
        pdfDoc.getPage(pageNum).then(function (page) {
          var viewport = page.getViewport(newScale);
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          // Render PDF page into canvas context
          var renderContext = {
            canvasContext: ctx,
            viewport: viewport
          };
          page.render(renderContext);
        });
      },
      zoomIn() {
        var scaleSelect = document.getElementById("scaleSelect");
        var last = scaleSelect.options.length - 1;
        if (scaleSelect.selectedIndex < last) {
          scale = scaleSelect.options[scaleSelect.selectedIndex + 1].value;
          scaleSelect.selectedIndex += 1;
          zoom(scale);
        }
      },
      zoomOut() {
        var scaleSelect = document.getElementById("scaleSelect");
        var last = scaleSelect.options.length - 1;
        if (scaleSelect.selectedIndex > 0) {
          scale = scaleSelect.options[scaleSelect.selectedIndex - 1].value;
          scaleSelect.selectedIndex -= 1;
          zoom(scale);
        }
      },
      zoomSelect() {
        var scaleSelect = document.getElementById("scaleSelect");
        scale = scaleSelect.options[scaleSelect.selectedIndex].value;
        zoom(scale);
      },
    }
  }

</script>
<style>
  #divPDFMobile {
    /*position: absolute;
    top: 140px;
    right: 0px;
    bottom: -140px;
    left: 0px;*/
    height: calc(100vh - 150px) !important;
    display: block;
    border: 1px solid black;
    overflow: scroll;
  }

  .btnZoomIn {
    position: absolute;
    color: #616161;
    background-color: #f2f2f2;
    right: 10px;
    bottom: 60px;
  }

  .btnZoomOut {
    position: absolute;
    color: #616161;
    background-color: #f2f2f2;
    right: 10px;
    bottom: 10px;
  }
  
</style>



// WEBPACK FOOTER //
// PDFMobile.vue?30d34216